/**
 * @generated SignedSource<<c20bc5d1136dd4e0fc275aeb6a5b72b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoStatus = "DONE" | "PENDING";
export type useWidgetTodoSubscriptionCreatedSubscription$variables = {
  categoryId: string;
  connections: ReadonlyArray<string>;
  teamIds: ReadonlyArray<string>;
};
export type useWidgetTodoSubscriptionCreatedSubscription$data = {
  readonly todoCreatedNew: {
    readonly todo: {
      readonly id: string;
      readonly ordinal: string;
      readonly status: TodoStatus;
      readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemWidget_Todo">;
    };
  } | null;
};
export type useWidgetTodoSubscriptionCreatedSubscription = {
  response: useWidgetTodoSubscriptionCreatedSubscription$data;
  variables: useWidgetTodoSubscriptionCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "categoryId",
    "variableName": "categoryId"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTodoSubscriptionCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoCreatedPayload",
        "kind": "LinkedField",
        "name": "todoCreatedNew",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TodoOverviewListItemWidget_Todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWidgetTodoSubscriptionCreatedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoCreatedPayload",
        "kind": "LinkedField",
        "name": "todoCreatedNew",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expireAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assigneeText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoAssignedUser",
                "kind": "LinkedField",
                "name": "assignedUsers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedAt",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "todo",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "TodoEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bad18ca8bc54ee8c0a26c70cac1a0041",
    "id": null,
    "metadata": {},
    "name": "useWidgetTodoSubscriptionCreatedSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTodoSubscriptionCreatedSubscription(\n  $categoryId: ID!\n  $teamIds: [ID!]!\n) {\n  todoCreatedNew(categoryId: $categoryId, teamIds: $teamIds) {\n    todo {\n      id\n      ordinal\n      status\n      ...TodoOverviewListItemWidget_Todo\n    }\n  }\n}\n\nfragment TodoCircleWidgetOverview_Todo on Todo {\n  expireAt\n  createdAt\n  status\n}\n\nfragment TodoOverviewListItemExpireInfo_Todo on Todo {\n  expireAt\n}\n\nfragment TodoOverviewListItemFooter_Todo on Todo {\n  tags {\n    id\n    color\n    title\n  }\n  assigneeText\n  assignedUsers {\n    user {\n      name\n      id\n    }\n    assignedAt\n    id\n  }\n}\n\nfragment TodoOverviewListItemWidget_Todo on Todo {\n  id\n  status\n  title\n  ...TodoOverviewListItemExpireInfo_Todo\n  ...TodoOverviewListItemFooter_Todo\n  ...TodoCircleWidgetOverview_Todo\n}\n"
  }
};
})();

(node as any).hash = "4ea7133f322fbfce7d00d24948812154";

export default node;
